import { addDays } from 'date-fns';
import { dateToFormat } from './formatters/date';

/**
 * Get the last day of the month
 * @param selectDate
 * @returns Date
 */
export const getLastDayOfMonth = (selectDate: string): Date => {
  const date = new Date(selectDate);
  const result = new Date(date.getFullYear(), date.getMonth() + 1, 1);
  return addDays(result, -1);
};

export const formatToDate = (fromDate: string, toDate?: string) => {
  if (toDate) {
    return dateToFormat(new Date(toDate), 'MM/dd/y');
  } else {
    const date = new Date(fromDate).getTime();
    const today = new Date().setHours(0, 0, 0, 0);
    return date < today ? 'Present' : '';
  }
};
